import { render, staticRenderFns } from "./preReceiptTable.vue?vue&type=template&id=28e2b3b4&"
import script from "./preReceiptTable.vue?vue&type=script&lang=js&"
export * from "./preReceiptTable.vue?vue&type=script&lang=js&"
import style0 from "./preReceiptTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports